/** Default values for Builder editor */
export const defaults = {
  children: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      children: [
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Text',
            options: {
              text: 'Enter some text...',
              style: 'Heading 1',
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              height: 'auto',
              textAlign: 'left',
              marginRight: 'auto',
            },
          },
        },
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Text',
            options: {
              text: 'Enter some text...',
              style: 'Body XL',
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              height: 'auto',
              textAlign: 'left',
              marginRight: 'auto',
              marginTop: '24px',
            },
          },
        },
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Button',
            options: {},
          },
          children: [
            {
              '@type': '@builder.io/sdk:Element',
              '@version': 2,
              component: {
                name: 'Text',
                options: {
                  text: '<span class="builder-text">CLICK ME!</span>',
                },
              },
            },
          ],
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              marginRight: 'auto',
              marginTop: '24px',
            },
          },
        },
      ],
      responsiveStyles: {
        large: {
          position: 'relative',
          flexShrink: '0',
          boxSizing: 'border-box',
          flexDirection: 'column',
          display: 'flex',
          height: '100%',
          justifyContent: 'center',
          color: 'rgba(255, 255, 255, 1)',
        },
      },
    },
  ],
  photoUrl:
    'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fa2175c4c26464ec1adf4eadcf5fababc',
}
